import { FormattedMessage } from 'react-intl';
import EmptyState from '@rio-cloud/rio-uikit/EmptyState';

interface EmptyProps {
    onCreateDriver: () => void;
}

export const Empty = ({ onCreateDriver }: EmptyProps) => (
    <div className={'display-flex justify-content-center'}>
        <EmptyState
            headline={<FormattedMessage id={'intl-msg:no.drivers'} />}
            buttons={[
                {
                    onClick: onCreateDriver,
                    text: <FormattedMessage id={'intl-msg:createDriver.addDriver.button'} />,
                },
            ]}
        />
    </div>
);
